import { Button, Col, Container, ListGroup, Row } from "react-bootstrap";
import {
  ModalSweetAlert,
  Notificacion,
} from "@components/general/Alertas/Alertas";
import { updateReorderLecciones } from "@helpers/httpRequests/httpRequestsLecciones/httpRequestsLecciones";

import React from "react";
import { useState } from "react";
import { closestCorners, DndContext, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { SortableItem } from "./SortableItem";
import { Item } from "./Item";

const getDragnDropListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#e3e3e3" : "#FFF",
  padding: 15,
  // width: 250
});

const getDragnDropItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: 10,
  // margin: `0 0 ${8}px 0`,
  background: isDragging ? "#FFF" : "transparent",
  ...draggableStyle,
});

const ListadoLeccionesSeccion = ({
  lecciones,
  setLecciones,
  recoveryLecciones,
}) => {
  const [editarLecciones, setEditarLecciones] = useState(false);

  const [activeId, setActiveId] = useState(null);
  

  const handleEditLecciones = () => {
    setEditarLecciones(true);
  };

  const handleCancelEditSecciones = () => {
    setLecciones(recoveryLecciones);

    setEditarLecciones(false);
  };

  const reorderLecciones = (list, startIndex, endIndex) => {
    const result = Array.from(list);

    const [removed] = result.splice(startIndex, 1);

    result.splice(endIndex, 0, removed);

    return result;
  };

  function handleDragStart(event) {
    const {active} = event;
    
    setActiveId(active.id);
  }

  const handleDragDropEnd = (result) => {

    const {active, over} = result;

    let leccionesReordenadas = [];
    
    const oldIndex = lecciones.indexOf(lecciones[active.id - 1]);
    const newIndex = lecciones.indexOf(lecciones[over.id - 1]);
    
    leccionesReordenadas = arrayMove(lecciones, oldIndex, newIndex);
    
    leccionesReordenadas.forEach((leccion, idx) => {
      const nuevoNivel = idx + 1;

      const nuevoNivelFormateado =
        nuevoNivel < 10 ? `0${nuevoNivel}` : nuevoNivel;

      leccionesReordenadas[idx] = {
        ...leccion,
        nivel: nuevoNivelFormateado,
      };
    });

    leccionesReordenadas.forEach((seccion, idx) => {
      const nuevoNivel = idx + 1;

      const nuevoNivelFormateado =
        nuevoNivel < 10 ? `0${nuevoNivel}` : nuevoNivel;

      leccionesReordenadas[idx] = {
        ...seccion,
        nivel: nuevoNivelFormateado,
      };
    });


    setLecciones(leccionesReordenadas);
  };

  const handleGuardarReorden = async () => {
    try {
      const isConfirmed = await ModalSweetAlert({
        title: "¿Estás seguro que deseas reordenar las lecciones?",
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        confirmButtonText: "Sí, reordenar",
        cancelButtonText: "No, cancelar",
      });

      if (!isConfirmed) {
        return;
      }

      await updateReorderLecciones(lecciones);

      Notificacion("success", "Las lecciones se reordenaron con éxito");

      setEditarLecciones(false);
    } catch (error) {
      console.log("Error al guardar el reorden: ", error);
      Notificacion("error", "No se pudieron reordenar las lecciones");
    }
  };

   const sensors = useSensors(
      useSensor(PointerSensor),
      useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
      })
    );

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col>
          {!editarLecciones && (
            <Button variant="primary" onClick={handleEditLecciones}>
              Cambiar orden de las lecciones
            </Button>
          )}

          {editarLecciones && (
            <>
              <Button
                className="me-2"
                variant="success"
                onClick={handleGuardarReorden}
              >
                Guardar
              </Button>

              <Button
                className="me-2"
                variant="danger"
                onClick={handleCancelEditSecciones}
              >
                Cancelar
              </Button>
            </>
          )}
        </Col>
      </Row>

      {editarLecciones && (
        <h5>Da clic y arrastra la lección al lugar donde deseas reordenarla</h5>
      )}

      <Row className="mt-3">
        <Col>
          {editarLecciones ? (
            <DndContext sensors={sensors} collisionDetection={closestCorners} onDragStart={handleDragStart} onDragEnd={handleDragDropEnd}>
              <SortableContext items={lecciones} strategy={verticalListSortingStrategy}>
                {lecciones.map((leccion, idx) => <SortableItem 
                key={idx + 1}
                id={idx + 1}
                idx={idx}
                leccionInfo={leccion}
                isLeccionSortable={true}
                />)}
              </SortableContext>
              <DragOverlay>
                {activeId ? <Item isLeccionItem={true} leccionInfo={lecciones[activeId - 1]} id={activeId} /> : null}
              </DragOverlay>
            </DndContext>
          ) : (
            <ListGroup>
              {lecciones.length > 0 ? (
                <>
                  {lecciones.map((leccion, idx) => (
                    <ListGroup.Item key={idx}>
                      {idx + 1}. {leccion.nombre} - {leccion.codigoLeccion}
                    </ListGroup.Item>
                  ))}
                </>
              ) : (
                <h3>No hay lecciones en esta sección</h3>
              )}
            </ListGroup>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ListadoLeccionesSeccion;
